import styled from "styled-components";
import {GameJackpotBarLabelDefaultBox} from "./game-jackpot-bar-label.default.box";
import {baseColors} from "../../../../../../themes/definitions/casino777/base-colors";

export const GameJackpotBarLabelCasino777Box = styled(GameJackpotBarLabelDefaultBox)`
    color: ${baseColors.base04Contrast};
    ${({theme}) => theme.font.presets.ultra};

    @media ${({theme}) => theme.mediaQuery.mAndAbove} {
        font-size: 1.4rem;
    }
`;